import { render, staticRenderFns } from "./SalesDataReport.vue?vue&type=template&id=2de38d52"
import script from "./SalesDataReport.vue?vue&type=script&lang=js"
export * from "./SalesDataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de38d52')) {
      api.createRecord('2de38d52', component.options)
    } else {
      api.reload('2de38d52', component.options)
    }
    module.hot.accept("./SalesDataReport.vue?vue&type=template&id=2de38d52", function () {
      api.rerender('2de38d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/SalesDataReport.vue"
export default component.exports